import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { transformResponseHandler } from "../../Utils/transformResponse";
import ApiRoutes from "../../Utils/ApiRoutes";
import { decrypt, encrypt } from "../../Utils/crypto";
import { apiEncrypted } from "../../Utils/function";

export const HistoryApis = createApi({
  reducerPath: "HistoryApis",
  baseQuery: async (args, api, extraOptions) => {
    const result = apiEncrypted(args, api, extraOptions)
    return result;   
  },  endpoints: (builder) => ({
    getHistory : builder.query({
      query: ({auditId}) => ({
        url: `${ApiRoutes.auditHistory}/${auditId}`,
        method: "GET",
      }),
      transformResponse: (res, meta) => transformResponseHandler(res, meta, false),
      transformErrorResponse: (error, meta) => transformResponseHandler(error,meta, true),
    }),
  }),
});

export const {useGetHistoryQuery } = HistoryApis;

